import { z } from "zod/v4";
const MailAddressSchema = z.email().brand();
export const MailAddress = {
    schema: MailAddressSchema,
};
//# sourceMappingURL=mail-address.js.map